app.views.errors = app.views.base.extend({
  childEvents: {},
  classes: {
    navigation: 'header-nav',
    footer: 'footer',
    actions: 'header-actions'
  },
  init: function init() {
    $('.' + this.classes.navigation).hide();
    $('.' + this.classes.footer).hide();
    $('.' + this.classes.actions).hide();
  }
});